import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsAddResolverErrorStatesEnum {
    GetCountriesFailed = ErrorStateScheduleEnum.PanelClientsAddResolverStatesStartIndex,
    GetCountriesInvalidData,
    GetConfidentialClientsFailed,
    GetConfidentialClientsInvalidData,
    GetPortalsFailed,
    GetPortalsInvalidData,
}
